// src/index.js
import React, { useContext, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import { LanguageProvider } from './contexts/LanguageContext';
import { SettingsProvider, SettingsContext } from './contexts/SettingsContext';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ContentPage from './components/ContentPage';
import { MantineProvider } from '@mantine/core';

// Use React.lazy to dynamically import the 3D pages
const ThreeDPage = lazy(() => import('./components/ThreeDPage')); 
const Place3DInImage = lazy(() => import('./components/Place3DInImage'));
// Removed: Lazy import for the R3F page

const MainApp = () => {
  const { settings } = useContext(SettingsContext);
  return (
    <MantineProvider theme={{ colorScheme: settings.theme }}>
      <Router>
        <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '2rem' }}>Loading...</div>}>
          <Routes>
            {/* <App> is at "/", we nest other routes like :slug inside */}
            <Route path="/" element={<App />}>
              <Route path=":slug" element={<ContentPage />} />
              <Route path="3d" element={<ThreeDPage />} />
              {/* Removed: AR and R3F routes */}
              <Route path="ar" element={<Place3DInImage />} />
            </Route>
          </Routes>
        </Suspense>
      </Router>
    </MantineProvider>
  );
};

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <LanguageProvider>
    <SettingsProvider>
      <MainApp />
    </SettingsProvider>
  </LanguageProvider>
);
